import { Tier } from '@tools/ui/types/generated/graphql';

export const NO_SUBSCRIPTION = 'No Subscription';
export const subscriptionTierMap = {
  basic: 0,
  plus: 1,
  core: 1,
  boost: 2,
  pro: 2,
  vip: 2,
  unlimited: 3
} as const;

export const TierMap: Partial<Record<Tier, string>> = {
  [Tier.MelioBasic]: 'Go',
  [Tier.MelioPlus]: 'Core',
  [Tier.MelioAccountingClientCore]: 'Firm Core',
  [Tier.MelioPro]: 'Boost',
  [Tier.MelioAccountingClientBoost]: 'Firm Boost',
  [Tier.MelioUnlimitedAch]: 'Unlimited',
  [Tier.MelioAccountingClientUnlimitedAch]: 'Firm Unlimited',
  [Tier.MelioUnlimitedFreeTrial]: 'Melio Unlimited Free Trial',
  [Tier.MelioAccountingClientUnlimitedFreeTrial]: 'Firm Unlimited Free Trial',
  [Tier.MelioVip]: 'VIP',
  [Tier.MelioAccountingFirm]: 'Accounting VIP'
};

export const ACCOUNTING_CLIENT = 'accounting_client';

export const ACCOUNTING_TIER_PREFIX = 'Accounting';

export const NO_VALUE = 'N/A';

export const SMB_TIER_BY_LEVEL = [
  TierMap[Tier.MelioBasic],
  TierMap[Tier.MelioPlus],
  TierMap[Tier.MelioPro],
  TierMap[Tier.MelioUnlimitedAch]
];

export const FIRM_TIER_BY_LEVEL = [
  TierMap[Tier.MelioBasic],
  TierMap[Tier.MelioAccountingClientCore],
  TierMap[Tier.MelioAccountingClientBoost],
  TierMap[Tier.MelioAccountingClientUnlimitedAch]
];
